// @flow
import React, { Component } from 'react'
import styled from 'styled-components'
import { Media, PaddedWrapper, MediaSpacer, CropWrapper } from '../AdEdit'
import type { ImageConfig, Crop } from '../types'
import PreviewImageCropperContainer from '../AdEdit/PreviewImageCropperContainer'
import AdditionalImageLoader from './AdditionalImageLoader'

const LoaderText = styled.span`
  font-size: 16px;
`

type Props = {|
  showImage: boolean,
  imageStoreId: ?string,
  loaderText: string,
  loaderTitle: string,
  cropperTitle: string,
  crop: ?Crop,
  imageConfigs: ImageConfig,
  errors: Array<string>,
  onLoad: Function,
  onChange: Function
|}

export default class AdditionalVkImageUploader extends Component<Props> {
  render() {
    const {
      showImage,
      imageStoreId,
      loaderText,
      loaderTitle,
      cropperTitle,
      crop,
      imageConfigs,
      errors,
      onLoad,
      onChange
    } = this.props

    return (
      <Media>
        <div>
          {showImage && !imageStoreId && (
            <PaddedWrapper>
              <LoaderText>{loaderText}</LoaderText>
              <AdditionalImageLoader
                onLoad={onLoad}
                titleParams={{ title: loaderTitle, fontSize: 16 }}
                storeId={imageStoreId}
                errors={errors}
                config={imageConfigs}
              />
            </PaddedWrapper>
          )}
        </div>
        <MediaSpacer />
        {imageStoreId && showImage && (
          <CropWrapper>
            <div>
              <PreviewImageCropperContainer
                title={cropperTitle}
                imageStoreId={imageStoreId}
                config={imageConfigs}
                crop={crop}
                onChange={(crop) => onChange(crop)}
              />
            </div>
            <div>
              <AdditionalImageLoader
                onLoad={onLoad}
                titleParams={{}}
                storeId={imageStoreId}
                errors={errors}
                config={imageConfigs}
              />
            </div>
          </CropWrapper>
        )}
      </Media>
    )
  }
}
